export default __webpack_public_path__ + "static/media/icon-instagram-link.3f6b5dbacb2237c6ca05ef1e651ee19e.svg";